<template>
  <div class="tw-relative tw-min-h-[calc(100vh-146px)] tw-bg-bgPage">
    <BaseTopLine> </BaseTopLine>
    <vue-tabs class="vue-tabs-type-1">
      <v-tab :title="dataLang['car']"> </v-tab>
      <!-- <v-tab :title="dataLang['commercial']"> </v-tab>
      <v-tab :title="dataLang['bike']"> </v-tab>
      <v-tab :title="dataLang['track']"> </v-tab>
      <v-tab :title="dataLang['trailer']"> </v-tab>
      <v-tab :title="dataLang['spec']"></v-tab> -->
      <v-tab :title="dataLang['air']"></v-tab>
      <v-tab :title="dataLang['water']"></v-tab>
    </vue-tabs>

    <div
      class="tw-flex tw-justify-between tw-items-center tw-px-[26px] tw-my-[15px]"
    >
      <button
        class="tw-app-btn-warning"
        @click="$modal.show('TariffModalCreate')"
      >
        {{ dataLang["tariff_register_text_97"] }}
      </button>

      <div class="tw-flex tw-gap-[15px]">
        <button @click="loadExel" class="tw-app-btn-external">
          {{ dataLang["tariff_register_text_121"] }}
        </button>

        <div
          class="tw-flex tw-gap-[15px] tw-p-[2px_16px] tw-items-center tw-border-solid tw-border-[1px] tw-border-forLine tw-rounded-[3px] tw-text-[12px] tw-text-forTitle"
        >
          <div>
            {{ dataLang["tariff_register_text_120"] }}
            <img
              :src="require(`@/assets/icons/questionForTooltip.svg`)"
              class="tw-w-[12px] tw-mb-[10px]"
              ref="tooltip"
              data-bs-toggle="tooltip"
              :title="dataLang['tariff_register_text_91']"
            />
          </div>

          <div class="tw-flex tw-gap-[5px] tw-items-center">
            <div
              :class="{
                'tw-opacity-50': comissionState,
                'tw-font-[600]': !comissionState,
              }"
            >
              {{ dataLang["tariff_register_text_89"] }}
            </div>
            <label class="form-switch">
              <input
                type="checkbox"
                :checked="comissionState"
                @input="(e) => changeComission(!!e.target.checked)"
              />
              <i></i>
            </label>
            <div
              :class="{
                'tw-opacity-50': !comissionState,
                'tw-font-[600]': comissionState,
              }"
            >
              {{ dataLang["tariff_register_text_90"] }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="tw-flex tw-justify-between tw-px-[26px] tw-my-[15px]">
      <div class="tw-flex">
        <button @click="loadData(1)" class="tw-app-btn-primary-outline">
          {{ dataLang["register_btn_filter_on"] }}
        </button>
        <button
          @click="resetFilter"
          class="tw-app-btn-light !tw-text-[#0056AF]"
        >
          {{ dataLang["register_btn_filter_off"] }}
        </button>
      </div>
      <TwBasePagination
        :page-count="numPages"
        :pagination-params="{
          ...paginationOrdersStateParams,
          limit: limitPaginationValue,
        }"
        :showLimitInput="true"
        @updateLimitValue="updateLimitValue"
        :page-range="10"
        :margin-pages="0"
        :click-handler="loadData"
      >
      </TwBasePagination>
    </div>

    <div class="tw-relative tw-h-full tw-px-[26px]">
      <BaseLoader v-if="localLoading"></BaseLoader>
      <div class="overflow-auto">
        <ve-table
          class="rest-style-table"
          style="width: 100%; min-width: 1600px"
          :columns="columns"
          :table-data="dataTable"
          :border-x="true"
          :border-y="true"
          row-key-field-name="orders__id"
          ref="mainTable"
          :eventCustomOption="eventCustomOption"
          :checkbox-option="{
            hideSelectAll: false,
          }"
          v-if="!localLoading"
          :clickHighlight="false"
          :cell-style-option="cellStyleOption"
          :rowStyleOption="{
            hoverHighlight: true,
          }"
          :cellSelectionOption="{ enable: false }"
        >
        </ve-table>
      </div>
    </div>

    <EditsTariffModal />
    <TariffModalCreate />
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import { VeTable } from "vue-easytable";
import GeneralService from "@/api/GeneralService";
import SmsPresetsModal from "./orders-modal/SmsPresetsModal.vue";
import EventBus from "@/event-bus.js";
import SendSomeSms from "@/components/reuse_modal/SendSomeSms.vue";
import { bootstrap, Tooltip } from "bootstrap";
import EditsTariffModal from "./tarrifs-modal/EditsTariffModal.vue";
import TariffModalCreate from "./tarrifs-modal/TariffModalCreate.vue";
import { VueTabs, VTab } from "vue-nav-tabs/dist/vue-tabs.js";
import httpInstance from "@/http-common";
export default {
  components: {
    VeTable,
    EditsTariffModal,
    TariffModalCreate,
    VueTabs,
    VTab,
  },

  data() {
    return {
      limitPaginationValue: 50,
      dataTimeSelect: { orders_from: [], orders_to: [] },
      selectsData: {
        types: [],
        statuses: [],
        ads: [],
        koef: [],
      },
      selectsFilter: {
        type: [],
        statuses: [],
        type_ts: [],
        type_body: [],
        ads: [],
        koef: [],
      },
      selects: [],
      statistics: {},
      countOrders: "",
      pincode: "",
      messageError: [],
      localLoading: true,
      dataTable: [],
      activeSelectRowsMultiple: [],
      filter: [],
      updatedValues: {},
      computedAllPage: 1,
      currentPage: 1,
      activePagePagination: {},
      testedloading: false,
      currentOpenedId: null,
      mainModalOpened: false,
      rowStyleOption: {
        stripe: true,
      },
      comissionState: false,
      cellSelectionOption: {
        enable: false,
      },
      eventCustomOption: {
        bodyRowEvents: ({ row, rowIndex }) => {
          return {
            dblclick: (event) => {
              this.$modal.show("EditsTariffModal", {
                id: row.tariff_for_car__id,
              });
            },
          };
        },
      },
      cellStyleOption: {
        headerCellClass: ({ column, rowIndex }) => {
          if (column.colorize) {
            return "bg-spec-table";
          }
        },
      },
    };
  },
  methods: {
    updateLimitValue(data) {
      this.limitPaginationValue = data;
      this.loadData();
    },
    async loadExel(urlToFetch) {
      GeneralService.get("/tariffs/file1")
        .then((data) => {
          window.open(data.data, "_blank");
        })
        .catch(() => {});
    },
    acceptDelete() {
      if (this.activeSelectRowsMultiple.length) {
        GeneralService.delete("/orders/" + this.activeSelectRowsMultiple, {
          ...(this.pincode && { pincode: this.pincode }),
        })
          .then((data) => {
            // this.selects.push(data.data.data.rows)

            this.loadData(1);
            this.$toast.success(data.data.message);
            this.$modal.hide("acceptDeleteWithPin");
          })
          .catch((e) => {
            if (e.response.status == 409) {
              this.$modal.show("acceptDeleteWithPin");
              this.messageError = e.response.data.message;
              this.$toast.error(e.response.data.message, { duration: 5000 });
            } else if (e.response.status == 400) {
              this.messageError = e.response.data.message;
              this.$toast.error(e.response.data.message, { duration: 5000 });
            }
          });
      } else {
        this.$toast.error("Выберите хотя-бы одно поле", { duration: 5000 });
      }
    },
    toArchive() {
      if (this.activeSelectRowsMultiple.length) {
        GeneralService.get(
          "/orders/to/archive/" + this.activeSelectRowsMultiple,
          {}
        )
          .then((data) => {
            // this.selects.push(data.data.data.rows)

            this.loadData(1);
            this.$toast.success(data.data.message);
          })
          .catch((e) => {
            // if (e.response.status == 409) {
            //   this.$modal.show('acceptDeleteWithPin')
            // }
          });
      } else {
        this.$toast.error("Выберите хотя-бы одно поле", { duration: 5000 });
      }
    },

    loadData(page = 1) {
      this.localLoading = true;
      Promise.all([
        GeneralService.get(
          "/settings?fields=company_settings__tariff_table_comission_custom_or_top_cars"
        ).then((data) => {
          this.comissionState =
            data.data.data.rows[0].company_settings__tariff_table_comission_custom_or_top_cars;
        }),
        GeneralService.get("/tariffs_groups_car").then((data) => {
          this.selectsData.koef = data.data.rows;
        }),
      ]).then(() => {
        GeneralService.get("/tariffs_car/table/main?joins=object,group", {
          params: {
            limit: this.limitPaginationValue,
            page: page,
            ...(this.filter.length && { where: JSON.stringify(this.filter) }),
          },
        }).then((data) => {
          this.dataTable = data.data.rows;
          this.getOrdersAll(data.data);
          this.localLoading = false;
        });
      });
    },
    resetFilter() {
      // this.selectsData
      this.filter = [];
      this.loadData(1);

      this.selectsFilter = {
        type: [],
        statuses: [],
      };
      this.dataTimeSelect = {
        orders_from: [],
        orders_to: [],
      };
      this.$refs.mainTable.$el
        .querySelectorAll("input.base-input--new")
        .forEach((elem, index) => {
          elem.value = "";
        });
    },
    fillFilter(data) {
      let newValueFilter =
        data.type == "like" ? `;percent;${data.value};percent;` : data.value;
      if (!this.filter.find((x) => x.field == data.name)) {
        this.filter.push({
          field: data.name,
          value: newValueFilter,
          ...(data.type == "like" && { operator: "like" }),
          ...(data.mod == "phone" && { mod: "phone" }),
        });
      } else {
        this.filter[this.filter.findIndex((x) => x.field == data.name)].value =
          newValueFilter;
      }
    },
    pincodeModalHandler() {
      this.pincode = "";
      this.activeSelectRowsMultiple = [];
      this.messageError = "";
    },
    changeComission(data) {
      GeneralService.edit("/tariffs_car/setcomissiontype", {
        company_settings__tariff_table_comission_custom_or_top_cars: data,
      }).then((data) => {
        this.loadData();
      });
    },
    prepareLabelsForDefaultSelects(data, keyDataFromFetch, toTranslate) {
      for (const key in data) {
        data[key].forEach((element) => {
          element["label"] = element[Object.keys(element).pop()];
          element["key"] = key;
          element["value"] = Object.keys(element)[0];
          element["selectName"] = keyDataFromFetch;
        });
      }
      return data;
    },
    ...mapActions("orderPagiation", ["getOrdersAll"]),
  },
  mounted() {
    EventBus.$on("updateContentDataTariff", () => {
      this.loadData();
    });
    let aaa = new Tooltip(this.$refs.tooltip, {});
    // this.$modal.show('EditsTariffModal', {
    //   id: 1
    // })
    // this.$modal.show('TariffModalCreate')
  },
  created() {
    Promise.all([
      // /orders/infopanel
      // GeneralService.get(
      //   `/tariffs_cars`
      // )
      //   .then((data) => {
      //
      //     // this.selects.push(data.data.data.rows)
      //     this.selectsData.ads = data.data.data.rows
      //   })
      //   .catch((e) => {
      //
      //   }),
    ]).then(() => {
      this.loadData(1);
    });
    // SSEEventSource.addEventListener('newOrder', (event) => {
    //   this.loadData(1)
    //   this.$toast.success('У вас новый заказ')

    //   if (
    //     this.settingInfoPanel
    //       .employee_profiles__is_active_order_notification_sound ||
    //     this.updatedValues.employee_profiles__is_active_order_notification_sound
    //   ) {
    //     this.soundClick()
    //   }
    // })
  },
  computed: {
    ...mapState("translationModule", ["dataLang"]),
    ...mapState("userSettingModule", ["userSetting"]),
    ...mapState("orderPagiation", ["paginationOrdersStateParams"]),
    ...mapGetters("orderPagiation", ["numPages"]),
    columns() {
      return [
        {
          title: this.dataLang["tariff_register_text_4"],
          children: [
            {
              field: "vehicles__id",
              key: "12",
              title: this.dataLang["tariff_register_text_12"],
              align: "center",
              width: "4%",
              ellipsis: {
                showTitle: true,
                lineClamp: 1,
              },
              renderHeaderCell: ({ column }, h) => {
                return (
                  <div class={"h-100"}>
                    <div style={"height: 50px"}></div>
                    <div class={"text-center"}>{column.title}</div>

                    <BaseInputNew
                      inputClass="tw-app-input-dark tw-app-input-dark-small"
                      placeholder=""
                      style={"min-width: 60px"}
                      disabled={false}
                      onInput={this.fillFilter}
                      additionalParams={{ type: "like" }}
                      inputName={"vehicles__id"}
                      value={""}
                      nameSign={""}
                    />
                  </div>
                );
              },
            },

            {
              field: "vehicles__name",
              key: "13",
              title: this.dataLang["tariff_register_text_13"],
              align: "left",
              width: "5%",

              ellipsis: {
                showTitle: true,
                lineClamp: 1,
              },
              renderHeaderCell: ({ column }, h) => {
                return (
                  <div>
                    <div style={"height: 50px"}></div>
                    <div class={"text-center"}>{column.title}</div>

                    <BaseInputNew
                      inputClass="tw-app-input-dark tw-app-input-dark-small"
                      placeholder=""
                      style={"min-width: 90px"}
                      disabled={false}
                      onInput={this.fillFilter}
                      additionalParams={{ type: "like" }}
                      inputName={"vehicles__name"}
                      value={""}
                      nameSign={""}
                    />
                  </div>
                );
              },
            },
            {
              field: "vehicles__year_release",
              key: "14",
              title: this.dataLang["tariff_register_text_14"],
              align: "left",
              width: 70,

              ellipsis: {
                showTitle: true,
                lineClamp: 1,
              },
              renderHeaderCell: ({ column }, h) => {
                return (
                  <div>
                    <div style={"height: 30px"}></div>
                    <div class={"text-center"}>{column.title}</div>
                  </div>
                );
              },
            },
            {
              field: "vehicles__gosnumber",
              key: "15",
              title: this.dataLang["tariff_register_text_15"],
              align: "center",
              width: 70,

              ellipsis: {
                showTitle: true,
                lineClamp: 1,
              },
              renderHeaderCell: ({ column }, h) => {
                return (
                  <div>
                    <div style={"height: 50px"}></div>
                    <div class={"text-center"}>{column.title}</div>

                    <BaseInputNew
                      inputClass="tw-app-input-dark tw-app-input-dark-small"
                      placeholder=""
                      style={"min-width: 60px"}
                      disabled={false}
                      onInput={this.fillFilter}
                      additionalParams={{ type: "like" }}
                      inputName={"vehicles__gosnumber"}
                      value={""}
                      nameSign={""}
                      inputRef={"vehicles__gosnumber"}
                      inputMask={"a000aa000"}
                      maxLength={"9"}
                    />
                  </div>
                );
              },
            },
            {
              field: "tariff_for_car__pledge",
              key: "153",
              title: this.dataLang["tariff_register_text_5"],
              align: "center",
              width: 70,

              ellipsis: {
                showTitle: true,
                lineClamp: 1,
              },
              renderHeaderCell: ({ column }, h) => {
                return (
                  <div>
                    <div style={"height: 30px"}></div>
                    <div class={"text-center"}>{column.title}</div>
                  </div>
                );
              },
              renderBodyCell: ({ row, column, rowIndex }, h) => {
                return <span>{row.tariff_for_car__pledge.split(".")[0]}</span>;
              },
            },
            {
              field: "tariff_groups_for_car__name",
              key: "16",
              title: this.dataLang["tariff_register_text_16"],
              align: "center",
              width: "8%",

              ellipsis: {
                showTitle: true,
                lineClamp: 1,
              },
              renderHeaderCell: ({ column }, h) => {
                return (
                  <div class={"multiselect-type-1 multiselect-type-1-small"}>
                    <div style={"height: 50px"}></div>
                    <div class={"text-center tw-text-nowrap"}>{column.title}</div>
                    <BaseSelect
                      vModel={this.selectsFilter.koef}
                      onInput={(e, w) => {
                        if (
                          !this.filter.find(
                            (x) => x.field == "tariff_groups_for_car__id"
                          )
                        ) {
                          this.filter.push({
                            field: "tariff_groups_for_car__id",
                            value: e.tariff_groups_for_car__id,
                          });
                        } else {
                          this.filter[
                            this.filter.findIndex(
                              (x) => x.field == "tariff_groups_for_car__id"
                            )
                          ].value = e.tariff_groups_for_car__id;
                        }
                      }}
                      style={"min-width: 60px"}
                      label={"tariff_groups_for_car__name"}
                      placeholder={""}
                      id={"tariff_groups_for_car__name"}
                      selectLabel={""}
                      deselectLabel={""}
                      options={this.selectsData.koef}
                    ></BaseSelect>
                  </div>
                );
              },
            },
          ],
        },
        {
          title: this.dataLang["tariff_register_text_6"],
          children: [
            {
              title: this.dataLang["tariff_register_text_47"],
              children: [
                {
                  title: "300 " + this.dataLang["tariff_register_text_64"],
                  children: [
                    {
                      field: "tariff_for_car__t1",
                      key: "tariff_for_car__t1",
                      title: this.dataLang["tariff_register_text_65"],
                      align: "center",
                      width: "3%",
                      edit: true,
                      ellipsis: {
                        showTitle: true,
                        lineClamp: 1,
                      },
                    },
                  ],
                },
              ],
            },
            {
              title: this.dataLang["tariff_register_text_48"],
              children: [
                {
                  title: "300 " + this.dataLang["tariff_register_text_64"],
                  children: [
                    {
                      field: "tariff_for_car__t2",
                      key: "tariff_for_car__t2",
                      title: this.dataLang["tariff_register_text_66"],
                      align: "center",
                      width: "3%",
                      edit: true,
                      ellipsis: {
                        showTitle: true,
                        lineClamp: 1,
                      },
                    },
                  ],
                },
              ],
            },
            {
              title: this.dataLang["tariff_register_text_49"],
              children: [
                {
                  title: "300 " + this.dataLang["tariff_register_text_64"],
                  children: [
                    {
                      field: "tariff_for_car__t3",
                      key: "tariff_for_car__t3",
                      title: this.dataLang["tariff_register_text_67"],
                      align: "center",
                      width: "3%",
                      edit: true,
                      ellipsis: {
                        showTitle: true,
                        lineClamp: 1,
                      },
                    },
                  ],
                },
              ],
            },
            {
              title: this.dataLang["tariff_register_text_50"],
              children: [
                {
                  title: "300 " + this.dataLang["tariff_register_text_64"],
                  children: [
                    {
                      field: "tariff_for_car__t4",
                      key: "12234",
                      title: this.dataLang["tariff_register_text_68"],
                      align: "center",
                      width: "3%",
                      edit: true,
                      ellipsis: {
                        showTitle: true,
                        lineClamp: 1,
                      },
                    },
                  ],
                },
              ],
            },
            {
              title: this.dataLang["tariff_register_text_51"],
              children: [
                {
                  title: "300 " + this.dataLang["tariff_register_text_64"],
                  children: [
                    {
                      field: "tariff_for_car__t5",
                      key: "11232",
                      title: this.dataLang["tariff_register_text_69"],
                      align: "center",
                      width: "3%",
                      edit: true,
                      ellipsis: {
                        showTitle: true,
                        lineClamp: 1,
                      },
                    },
                  ],
                },
              ],
            },
            {
              title: this.dataLang["tariff_register_text_52"],
              children: [
                {
                  title: "300 " + this.dataLang["tariff_register_text_64"],
                  children: [
                    {
                      field: "tariff_for_car__t6",
                      key: "34312",
                      title: this.dataLang["tariff_register_text_70"],
                      align: "center",
                      width: "3%",
                      edit: true,
                      ellipsis: {
                        showTitle: true,
                        lineClamp: 1,
                      },
                    },
                  ],
                },
              ],
            },
            {
              title: this.dataLang["tariff_register_text_53"],
              children: [
                {
                  title: "225 " + this.dataLang["tariff_register_text_64"],
                  children: [
                    {
                      field: "tariff_for_car__t7",
                      key: "15432",
                      title: this.dataLang["tariff_register_text_71"],
                      align: "center",
                      width: "3%",
                      edit: true,
                      ellipsis: {
                        showTitle: true,
                        lineClamp: 1,
                      },
                    },
                  ],
                },
              ],
            },
            {
              title: this.dataLang["tariff_register_text_54"],
              children: [
                {
                  title: "225 " + this.dataLang["tariff_register_text_64"],
                  children: [
                    {
                      field: "tariff_for_car__t8",
                      key: "1234",
                      title: this.dataLang["tariff_register_text_72"],
                      align: "center",
                      width: "3%",
                      edit: true,
                      ellipsis: {
                        showTitle: true,
                        lineClamp: 1,
                      },
                    },
                  ],
                },
              ],
            },
            {
              title: this.dataLang["tariff_register_text_55"],
              children: [
                {
                  title: "125 " + this.dataLang["tariff_register_text_64"],
                  children: [
                    {
                      field: "tariff_for_car__t9",
                      key: "1245",
                      title: this.dataLang["tariff_register_text_73"],
                      align: "center",
                      width: "3%",
                      edit: true,
                      ellipsis: {
                        showTitle: true,
                        lineClamp: 1,
                      },
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          title: this.dataLang["tariff_register_text_7"],
          children: [
            {
              title: this.dataLang["tariff_register_text_56"],
              children: [
                {
                  field: "tariff_for_car__km_up",
                  key: "1762",
                  title: this.dataLang["tariff_register_text_74"],
                  align: "center",
                  width: "3%",
                  ellipsis: {
                    showTitle: true,
                    lineClamp: 1,
                  },
                  renderBodyCell: ({ row, column, rowIndex }, h) => {
                    return row.tariff_for_car__km_up
                      ? row.tariff_for_car__km_up.split(".")?.[0]
                      : "";
                  },
                },
              ],
            },
          ],
        },
        {
          title: this.dataLang["tariff_register_text_8"],
          children: [
            {
              title: this.dataLang["tariff_register_text_57"],
              children: [
                {
                  field: "tariff_for_car__fr",
                  key: "1552",
                  title: this.dataLang["tariff_register_text_75"],
                  align: "center",
                  width: "3%",
                  ellipsis: {
                    showTitle: true,
                    lineClamp: 1,
                  },
                  renderBodyCell: ({ row, column, rowIndex }, h) => {
                    return row.tariff_for_car__fr
                      ? row.tariff_for_car__fr.split(".")?.[0]
                      : "";
                  },
                },
              ],
            },
            {
              title: this.dataLang["tariff_register_text_58"],
              children: [
                {
                  field: "tariff_for_car__day_fr",
                  key: "12325",
                  title: this.dataLang["tariff_register_text_76"],
                  align: "center",
                  width: "3%",
                  ellipsis: {
                    showTitle: true,
                    lineClamp: 1,
                  },
                  renderBodyCell: ({ row, column, rowIndex }, h) => {
                    return row.tariff_for_car__day_fr
                      ? row.tariff_for_car__day_fr.split(".")?.[0]
                      : "";
                  },
                },
              ],
            },
          ],
        },
        {
          title: this.dataLang["tariff_register_text_44"],
          children: [
            {
              title: this.dataLang["tariff_register_text_27"],
              children: [
                {
                  title:
                    "3000\u00A0" + this.dataLang["tariff_register_text_64"],
                  children: [
                    {
                      field: "tariff_for_car__sub_1",
                      key: "1242",
                      title: this.dataLang["tariff_register_text_77"],
                      align: "center",
                      width: "3%",
                      edit: true,
                      ellipsis: {
                        showTitle: true,
                        lineClamp: 1,
                      },
                    },
                  ],
                },
              ],
            },
            {
              title: this.dataLang["tariff_register_text_28"],
              children: [
                {
                  title:
                    "7000\u00A0" + this.dataLang["tariff_register_text_64"],
                  children: [
                    {
                      field: "tariff_for_car__sub_3",
                      key: "1212",
                      title: this.dataLang["tariff_register_text_78"],
                      align: "center",
                      width: "3%",
                      edit: true,
                      ellipsis: {
                        showTitle: true,
                        lineClamp: 1,
                      },
                    },
                  ],
                },
              ],
            },
            {
              title: this.dataLang["tariff_register_text_29"],
              children: [
                {
                  title:
                    "13000\u00A0" + this.dataLang["tariff_register_text_64"],
                  children: [
                    {
                      field: "tariff_for_car__sub_6",
                      key: "12332",
                      title: this.dataLang["tariff_register_text_79"],
                      align: "center",
                      width: "3%",
                      edit: true,
                      ellipsis: {
                        showTitle: true,
                        lineClamp: 1,
                      },
                    },
                  ],
                },
              ],
            },
            {
              title: this.dataLang["tariff_register_text_30"],
              children: [
                {
                  title:
                    "19000\u00A0" + this.dataLang["tariff_register_text_64"],
                  children: [
                    {
                      field: "tariff_for_car__sub_9",
                      key: "12172",
                      title: this.dataLang["tariff_register_text_80"],
                      align: "center",
                      width: "3%",
                      edit: true,
                      ellipsis: {
                        showTitle: true,
                        lineClamp: 1,
                      },
                    },
                  ],
                },
              ],
            },
            {
              title: this.dataLang["tariff_register_text_31"],
              children: [
                {
                  title:
                    "25000\u00A0" + this.dataLang["tariff_register_text_64"],
                  children: [
                    {
                      field: "tariff_for_car__sub_12",
                      key: "12334",
                      title: this.dataLang["tariff_register_text_81"],
                      align: "center",
                      width: "3%",
                      edit: true,
                      ellipsis: {
                        showTitle: true,
                        lineClamp: 1,
                      },
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          title: this.dataLang["tariff_register_text_45"],
          children: [
            {
              title: this.dataLang["tariff_register_text_31"],
              children: [
                {
                  title:
                    "25000\u00A0" + this.dataLang["tariff_register_text_64"],
                  children: [
                    {
                      field: "tariff_for_car__buy_12",
                      key: "12423",
                      title: this.dataLang["tariff_register_text_82"],
                      align: "center",
                      width: "3%",
                      edit: true,
                      ellipsis: {
                        showTitle: true,
                        lineClamp: 1,
                      },
                    },
                  ],
                },
              ],
            },
            {
              title: this.dataLang["tariff_register_text_32"],
              children: [
                {
                  title:
                    "50000\u00A0" + this.dataLang["tariff_register_text_64"],
                  children: [
                    {
                      field: "tariff_for_car__buy_24",
                      key: "12423",
                      title: this.dataLang["tariff_register_text_83"],
                      align: "center",
                      width: "3%",
                      edit: true,
                      ellipsis: {
                        showTitle: true,
                        lineClamp: 1,
                      },
                    },
                  ],
                },
              ],
            },
            {
              title: this.dataLang["tariff_register_text_113"],
              children: [
                {
                  title:
                    "75000\u00A0" + this.dataLang["tariff_register_text_64"],
                  children: [
                    {
                      field: "tariff_for_car__buy_36",
                      key: "12423",
                      title: this.dataLang["tariff_register_text_84"],
                      align: "center",
                      width: "3%",
                      edit: true,
                      ellipsis: {
                        showTitle: true,
                        lineClamp: 1,
                      },
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          title: this.dataLang["tariff_register_text_11"],
          children: [
            {
              title: this.dataLang["tariff_register_text_33"],
              children: [
                {
                  field: "tariff_for_car__drive",
                  key: "1245233",
                  title: this.dataLang["tariff_register_text_85"],
                  align: "center",
                  width: "3%",
                  ellipsis: {
                    showTitle: true,
                    lineClamp: 1,
                  },
                },
              ],
            },
          ],
        },
        {
          field: "tariff_for_car__commission_place",
          key: "12422133",
          title: this.dataLang["tariff_register_text_115"],
          align: "center",
          width: "3%",
          colorize: true,
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={"text-center"}>{column.title}</div>
                <div style={"min-width: 100px"}></div>
              </div>
            );
          },
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <div>
                {Number(row.tariff_for_car__commission_place).toFixed(0)}
              </div>
            );
          },
        },
        {
          title: this.dataLang["tariff_register_text_120"],
          colorize: true,
          children: [
            {
              field: "tariff_for_car__commission_nodriver_day",
              key: "1242133",
              title: this.dataLang["tariff_register_text_43"],
              align: "center",
              width: "3%",
              colorize: true,
              ellipsis: {
                showTitle: true,
                lineClamp: 1,
              },
              renderHeaderCell: ({ column }, h) => {
                return (
                  <div>
                    <div class={"text-center"}>{column.title}</div>

                    <div style={"min-width: 100px"}></div>
                  </div>
                );
              },
              renderBodyCell: ({ row, column, rowIndex }, h) => {
                return (
                  <div>
                    {Number(
                      row.tariff_for_car__commission_nodriver_day
                    ).toFixed(0)}{" "}
                    /{" "}
                    <span style={"color: #23b14d"}>
                      {Number(
                        row.tariff_for_car__commission_nodriver_day_top
                      ).toFixed(0)}
                      %
                    </span>
                  </div>
                );
              },
            },
            {
              field: "tariff_for_car__commission_nodriver_subs",
              key: "1242333",
              title: this.dataLang["tariff_register_text_44"],
              align: "center",
              width: "3%",
              colorize: true,
              ellipsis: {
                showTitle: true,
                lineClamp: 1,
              },
              renderHeaderCell: ({ column }, h) => {
                return (
                  <div>
                    <div class={"text-center"}>{column.title}</div>

                    <div style={"min-width: 100px"}></div>
                  </div>
                );
              },
              renderBodyCell: ({ row, column, rowIndex }, h) => {
                return (
                  <div>
                    {Number(
                      row.tariff_for_car__commission_nodriver_subs
                    ).toFixed()}{" "}
                    /{" "}
                    <span style={"color: #23b14d"}>
                      {Number(
                        row.tariff_for_car__commission_nodriver_subs_top
                      ).toFixed()}
                      %
                    </span>
                  </div>
                );
              },
            },

            {
              field: "tariff_for_car__commission_nodriver_buyout",
              key: "1242533",
              title: this.dataLang["tariff_register_text_45"],
              align: "center",
              width: "3%",
              colorize: true,
              ellipsis: {
                showTitle: true,
                lineClamp: 1,
              },
              renderHeaderCell: ({ column }, h) => {
                return (
                  <div>
                    <div class={"text-center"}>{column.title}</div>

                    <div style={"min-width: 100px"}></div>
                  </div>
                );
              },
              renderBodyCell: ({ row, column, rowIndex }, h) => {
                return (
                  <div>
                    {Number(
                      row.tariff_for_car__commission_nodriver_buyout
                    ).toFixed()}{" "}
                    /{" "}
                    <span style={"color: #23b14d"}>
                      {Number(
                        row.tariff_for_car__commission_nodriver_buyout_top
                      ).toFixed()}
                      %
                    </span>
                  </div>
                );
              },
            },
            {
              field: "tariff_for_car__commission_driver",
              key: "1242303",
              title: this.dataLang["tariff_register_text_11"],
              align: "center",
              width: "3%",
              colorize: true,
              ellipsis: {
                showTitle: true,
                lineClamp: 1,
              },
              renderHeaderCell: ({ column }, h) => {
                return (
                  <div>
                    <div class={"text-center"}>{column.title}</div>

                    <div style={"min-width: 100px"}></div>
                  </div>
                );
              },
              renderBodyCell: ({ row, column, rowIndex }, h) => {
                return (
                  <div>
                    {Number(row.tariff_for_car__commission_driver).toFixed()} /{" "}
                    <span style={"color: #23b14d"}>
                      {Number(
                        row.tariff_for_car__commission_driver_top
                      ).toFixed()}
                      %
                    </span>
                  </div>
                );
              },
            },
          ],
        },
      ];
    },
  },
};
</script>

<style scoped>
.form-switch {
  display: inline-flex;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  padding-left: 0;
}

.form-switch i {
  position: relative;
  display: inline-block;
  margin-right: 0.5rem;
  width: 46px;
  height: 26px;
  background-color: #f5f5f5;
  border-radius: 23px;
  vertical-align: text-bottom;
  transition: all 0.3s linear;
  outline: 1px solid #dce0ed;
}

.form-switch i::before {
  content: "";
  position: absolute;
  left: 0;
  width: 42px;
  height: 22px;
  background-color: #f5f5f5;
  border-radius: 11px;
  transform: translate3d(2px, 2px, 0) scale3d(1, 1, 1);
  transition: all 0.25s linear;
}

.form-switch i::after {
  content: "";
  position: absolute;
  left: 0;
  width: 22px;
  height: 22px;
  background-color: #23b14d;
  border-radius: 11px;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.24);
  transform: translate3d(2px, 2px, 0);
  transition: all 0.2s ease-in-out;
}

.form-switch:active i::after {
  width: 28px;
  transform: translate3d(2px, 2px, 0);
}

.form-switch:active input:checked + i::after {
  transform: translate3d(16px, 2px, 0);
}

.form-switch input {
  display: none;
}

.form-switch input:checked + i::before {
  transform: translate3d(18px, 2px, 0) scale3d(0, 0, 0);
}

.form-switch input:checked + i::after {
  transform: translate3d(22px, 2px, 0);
}
</style>
